import { get } from '../../../utils/object-helpers';
import { ajax } from '../../../utils/ajax-handler';
import { getGlobals } from '../../../utils/global-variables';

export default class {
    init(input) {
        this.input = input;
        const { isWatching } = input;
        const { baseUrl, unwatchToken, watchToken } = getGlobals();
        this.state = {
            error: null,
            isWatching,
            addWatchAjax: this.getAddWatchAjax(watchToken, baseUrl),
            removeWatchAjax: this.getRemoveWatchAjax(unwatchToken, baseUrl)
        };
    }
    onCreate(input) {
        this.init(input);
    }
    onInput(input) {
        this.init(input);
    }
    toggleWatch(evt) {
        evt.stopPropagation();
        evt.preventDefault();
        this.getEl('watchBtn').style.display = 'none'; // Hide heart icon
        this.getEl('watchBtn').nextSibling.style.display = 'block'; // Show spinner
        const watchAjax = this.state.isWatching ? this.state.removeWatchAjax : this.state.addWatchAjax;
        ajax({
            url: watchAjax.url,
            responseType: 'json',
            withCredentials: false
        }, {
            successCallBack: this.handleWatchSuccess.bind(this),
            errorCallBack: this.handleWatchFailure.bind(this)
        });
    }
    handleWatchSuccess(response) {
        this.getEl('watchBtn').nextSibling.style.display = 'none'; // Hide spinner
        this.getEl('watchBtn').style.display = 'block'; // Show heart icon
        const redirectResponse = get(response, 'modules.redirect.reload', null);
        const watchResponse = get(response, 'listDetails.[0].itemAdded', null);
        const unwatchResponse = get(response, 'responses.[0].statusCode', '');
        if (redirectResponse === true) {
            window.location.href = get(response, 'modules.redirectUrl', '');
        } else if (watchResponse === true) {
            this.state.isWatching = true;
        } else if (unwatchResponse === '200') {
            this.state.isWatching = false;
        }
    }
    handleWatchFailure() {
        this.getEl('watchBtn').nextSibling.style.display = 'none'; // Hide spinner
        this.getEl('watchBtn').style.display = 'block'; // Show heart icon
    }
    getAddWatchAjax(token, baseUrl) {
        const watch = get(this.input, 'watch', {});
        const itemId = get(this.input, 'watch.action.params.itemId', '');
        return {
            url: `${baseUrl}/mye/myebay/ajax/watch/watchInline?itemId=${itemId}&srt=${token}`,
            tracking: this.getTracking(watch),
            title: this.getTitle(watch)
        };
    }
    getRemoveWatchAjax(token, baseUrl) {
        const watching = get(this.input, 'watching', {});
        const itemId = get(this.input, 'watch.action.params.itemId', '');
        return {
            url: `${baseUrl}/mye/myebay/ajax/watch/unwatchInline?itemId=${itemId}&srt=${token}`,
            tracking: this.getTracking(watching),
            title: this.getTitle(watching)
        };
    }
    getUrl(watchObject, token) {
        const url = get(watchObject, 'action.URL', '');
        return token ? `${url}&srt=${token}` : url;
    }
    getTracking(watchObject) {
        return JSON.stringify(get(watchObject, 'action.trackingList.0', {}));
    }
    getTitle(watchObject) {
        return get(watchObject, 'text.accessibilityText', '');
    }
}
